export const getAssetUrl = (src = "") => {
  return src;
};

export const isAirgapped = () => {
  return false;
};
